import { render, staticRenderFns } from "./gs-wizard-step.vue?vue&type=template&id=46e9e3b6&scoped=true"
import script from "./gs-wizard-step.vue?vue&type=script&lang=ts"
export * from "./gs-wizard-step.vue?vue&type=script&lang=ts"
import style0 from "./gs-wizard-step.vue?vue&type=style&index=0&id=46e9e3b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e9e3b6",
  null
  
)

export default component.exports